export default __webpack_public_path__ + "static/media/passenger-transit-compressed.1d9fb3dc.jpg";